import * as React from 'react';

import {Button} from '../button/button';
import {DistributionBar} from '../card/distribution-bar/distribution-bar';
import type {DistributionBarSection} from '../card/distribution-bar/types';
import {Stack} from '../layout/stack/stack';
import {PopoverInfo} from '../popover-info/popover-info';

import {FunnelBar} from './funnel-bar';
import type {DistributionBarItem} from './funnel-chart';
import {FunnelDelta} from './funnel-delta';
import type {FunnelChartRenderItem} from './helpers';

import styles from './funnel-chart.module.css';

type Props = {
    item: FunnelChartRenderItem;
};

const MIN_WIDTH_PERCENT = 10;

const getDistributionBarSections = (
    distributionBar?: DistributionBarItem[]
): DistributionBarSection[] => {
    if (!distributionBar || distributionBar.length === 0) {
        return [];
    }

    return distributionBar.map((item) => ({
        color: item.color,
        value: item.value,
        label: item.label,
        labelColor: 'black',
    }));
};

export const FunnelCard = (props: Props) => {
    const hasDistributionBar = props.item.distributionBar && props.item.distributionBar.length > 0;
    const distributionBarSections = getDistributionBarSections(props.item.distributionBar);

    let funnelBar = null;
    if (hasDistributionBar) {
        funnelBar = (
            <div style={{width: `${props.item.width}%`}}>
                <DistributionBar
                    proportional={true}
                    sections={distributionBarSections}
                    minWidthPercent={MIN_WIDTH_PERCENT}
                    borderVariant='dark'
                    size='compact'
                />
            </div>
        );
    } else {
        funnelBar = (
            <FunnelBar
                value={props.item.value}
                valuePrefix={props.item.valuePrefix}
                valueSubtitle={props.item.valueSubtitle}
                width={props.item.width}
                onClick={props.item.onClickFunnelBar}
                isHoverable={props.item.isHoverable}
            />
        );
    }

    return (
        <div className={styles['funnel-card']}>
            <Stack spacing={4}>
                <Stack isHorizontal={true}>
                    <Button
                        variant='text-secondary'
                        size='xlarge'
                        onClick={props.item.onClickTitle}
                        noPadding={true}
                    >
                        {props.item.title}
                    </Button>
                    {props.item.tooltip && (
                        <PopoverInfo
                            info={props.item.tooltip}
                            size={20}
                            variant='blue'
                            bodyColor='dark'
                        />
                    )}
                </Stack>
                <Stack spacing={16} alignItems='center'>
                    {funnelBar}
                    {props.item.delta != null && <FunnelDelta delta={props.item.delta} />}
                </Stack>
            </Stack>
        </div>
    );
};
